import script from "./PlanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanCard.vue?vue&type=script&setup=true&lang=js"

import "./PlanCard.vue?vue&type=style&index=0&id=70b95eb0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b95eb0"]])

export default __exports__